<ng-container *transloco="let t; read: 'authentication'">
  <button mat-button (click)="clickEvent.emit()" (keyup.enter)="clickEvent.emit()" (keyup.space)="clickEvent.emit()">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
    {{ t('BACK_TO_SOCIAL_SIGN_IN') }}
  </button>

  <div class="ao-firebaseui-container">
    <div #firebseuiAuthContainer id="firebseui-auth-container"></div>
  </div>
</ng-container>
